import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MaterialModule } from './material.module';
import { CovalentModule } from './covalent.module';
import { NgxMaskModule } from 'ngx-mask';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LoanQuoteComponent } from './loan-quote/loan-quote.component';

import { environment } from '@env/environment';

import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { KwEstimateComponent } from './kw-estimate/kw-estimate.component';
import { NoCityComponent } from './no-city/no-city.component';
import { ResultComponent } from './result/result.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LoanQuoteComponent,
    KwEstimateComponent,
    NoCityComponent,
    ResultComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MaterialModule,
    CovalentModule,
    FlexLayoutModule,
    NgxMaskModule.forRoot({ validation: true }),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.ERROR,
      disableConsoleLogging: false
    }),
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [KwEstimateComponent, NoCityComponent, ResultComponent]
})
export class AppModule { }
